import {
  FEATURED_COMMUNITY_ID_BOTTOM,
  FEATURED_COMMUNITY_ID_TOP,
  FEATURED_COMMUNITY_IDS,
} from "@/consts/communities";

export function categorizeCommunities(data: any[]) {
  return {
    communities: data,
    certificationCommunities: data.filter((community: any) => {
      return community.Category == "Professional/Expert";
    }),
    associateCommunities: data.filter((community: any) => {
      return community.Category == "Associate";
    }),
    moreCommunities: data.filter((community: any) => {
      return (
        community.Category != "Professional/Expert" &&
        community.Category != "Associate"
      );
    }),
    communitythreads: data.filter((community: any) => {
      return FEATURED_COMMUNITY_IDS.includes(community.Id);
    }),
    communitytop: data.filter((community: any) => {
      return community.Id === FEATURED_COMMUNITY_ID_TOP;
    }),
    communitybottom: data.filter((community: any) => {
      return community.Id === FEATURED_COMMUNITY_ID_BOTTOM;
    }),
  };
}
